// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"703":"b5d70891","726":"c933adee","906":"db2cba1d"}[chunkId] + ".js";
};